import React from 'react'
import { ClinicDashBoard3 } from '../components/dashboards/ClinicDashBoard3'
import { Route, Routes } from 'react-router-dom'
import { ClinicsList } from '../components/shared/admin/ClinicsList'
import { Clinic } from '../layouts/Clinic'

export const AdminServices = () => {
    return (
        <section className='bg-[#f5f5f5] justify-around w-full flex  flex-auto'>
            <div className='w-[55%]'>
                <Routes>
                    <Route path='/' element={<ClinicsList />} />
                    <Route path='/*' element={<Clinic />} />
                </Routes>
            </div>
            <div className='w-[35%]'>
                <ClinicDashBoard3 />
            </div>
        </section>
    )
}
